type ArActionButtonProps = {
	isVisible: boolean;
	disabled: boolean;
	onClick: () => void;
};

const LABEL = 'See it in your space';

/**
 * Compact, translucent AR entry point pinned to the canvas corner. Icon-only
 * so it stays out of the way of the scene on small screens; the wording lives
 * in the accessible name and the tooltip.
 */
export const ArActionButton = ({ isVisible, disabled, onClick }: ArActionButtonProps): React.ReactElement | null => {
	if (!isVisible) return null;

	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			aria-label={LABEL}
			title={LABEL}
			style={{
				position: 'absolute',
				top: '12px',
				right: '12px',
				width: '40px',
				height: '40px',
				padding: 0,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				borderRadius: '50%',
				border: '1px solid rgba(0, 0, 0, 0.08)',
				backgroundColor: 'rgba(255, 255, 255, 0.78)',
				color: '#1f2328',
				backdropFilter: 'blur(10px)',
				WebkitBackdropFilter: 'blur(10px)',
				boxShadow: '0 1px 4px rgba(0, 0, 0, 0.12)',
				cursor: disabled ? 'wait' : 'pointer',
				opacity: disabled ? 0.5 : 0.92,
				zIndex: 100,
				transition: 'opacity 0.15s ease, transform 0.15s ease',
				touchAction: 'manipulation',
				WebkitTapHighlightColor: 'transparent',
				userSelect: 'none'
			}}
			onMouseEnter={(event: React.MouseEvent<HTMLButtonElement>) => {
				if (!disabled) event.currentTarget.style.opacity = '1';
			}}
			onMouseLeave={(event: React.MouseEvent<HTMLButtonElement>) => {
				if (!disabled) event.currentTarget.style.opacity = '0.92';
			}}
			onPointerDown={(event: React.PointerEvent<HTMLButtonElement>) => {
				if (!disabled) event.currentTarget.style.transform = 'scale(0.94)';
			}}
			onPointerUp={(event: React.PointerEvent<HTMLButtonElement>) => {
				event.currentTarget.style.transform = 'none';
			}}
			onPointerCancel={(event: React.PointerEvent<HTMLButtonElement>) => {
				event.currentTarget.style.transform = 'none';
			}}
		>
			<svg
				width="22"
				height="22"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.7"
				strokeLinecap="round"
				strokeLinejoin="round"
				aria-hidden="true"
			>
				<path d="M4 8V6a2 2 0 0 1 2-2h2" />
				<path d="M16 4h2a2 2 0 0 1 2 2v2" />
				<path d="M20 16v2a2 2 0 0 1-2 2h-2" />
				<path d="M8 20H6a2 2 0 0 1-2-2v-2" />
				<path d="M12 7.6l4.2 2.4v4.8L12 17.2l-4.2-2.4v-4.8L12 7.6z" />
				<path d="M12 12.4l4.2-2.4" />
				<path d="M12 12.4v4.8" />
				<path d="M12 12.4L7.8 10" />
			</svg>
		</button>
	);
};
